/**
 * 认证 API 模块
 * 登录/登出走 Rust IPC 代理（Token 获取+存储），其他 CRUD 直连后端
 */
import { ipcCall } from '@/composables/useIPC'
import { IpcCommand } from '@/types/ipc'
import { get, post } from '@/api/client'

/** 登录 — 通过 IPC 代理到 Rust（Token 安全存储） */
export function login(data: LoginReq) {
  return ipcCall<LoginRes>(IpcCommand.AuthLogin, data as unknown as Record<string, unknown>)
}

/** 登出 — 通过 IPC 代理到 Rust（清除本地 Token） */
export function logout() {
  return ipcCall<void>(IpcCommand.AuthLogout)
}

/** 获取当前用户信息 — 通过 Rust 代理（防 XSS 篡改菜单） */
export function getUserInfo(options?: RequestOptions) {
  return get<{ userInfo?: UserInfoRes; user?: UserInfoRes } | UserInfoRes>('/user/getUserInfo', options).then(
    (data) => {
      if ('userInfo' in data && data.userInfo) return data.userInfo
      if ('user' in data && data.user) return data.user
      return data as UserInfoRes
    },
  )
}

/** 发送找回密码短信验证码 */
export function sendForgotPasswordCode(data: SendForgotPasswordCodeReq) {
  return post<SendForgotPasswordCodeRes>('/base/sendForgotPasswordCode', data)
}

/** 找回密码确认修改 */
export function resetForgotPassword(data: ResetForgotPasswordReq) {
  return post<void>('/base/resetForgotPassword', data)
}

/** 登录后修改当前用户密码 */
export function changePassword(data: ChangePasswordReq) {
  return post<void>('/user/changePassword', data)
}
